import PaymentDataModeFirst from "app/pages/Booking/Payment/PaymentData/PaymentDataModeFirst/PaymentDataModeFirst";
import { connect } from "react-redux";
import {
	calculatePartialPaymentAmount,
	checkIfPaymentPledg4xDisponible,
	getAllowedPaymentTypes,
	getEcheancierCasino,
	getPaymentModes,
	getSupportedPaymentTypes,
} from "app/pages/Booking/Payment/paymentSelector";
import {
	getQuoteTotalWithDelta,
	isBookingEligibleForDeposit,
} from "app/pages/Booking/bookingSelectors";
import { bindActionCreators } from "redux";
import { updateBooking } from "app/pages/Booking/bookingActionCreators";

import React from "react";
import { FormattedMessage } from "react-intl";
import { FRANCE_DOM_COUNTRIES } from "app/constants";
import { isOperatorMode } from "app/pages/Auth/authSelectors";
import get from "lodash/get";
import { isDepositEnabled } from "app/pages/.shared/Deposit/depositSelector";

const mapStateToProps = (state, ownProps) => {
	const total = getQuoteTotalWithDelta(state);

	let payment4XForbiddenCause;

	if (total < state.payment.payment4x.minAmount) {
		payment4XForbiddenCause = (
			<FormattedMessage
				id="error.payment.external.min.error"
				values={{ minAmount: state.payment.payment4x.minAmount }}
			/>
		);
	} else if (total > state.payment.payment4x.maxAmount) {
		payment4XForbiddenCause = (
			<FormattedMessage
				id="error.payment.external.max.error"
				values={{ maxAmount: state.payment.payment4x.maxAmount }}
			/>
		);
	} else if (
		FRANCE_DOM_COUNTRIES.indexOf(get(ownProps, "fields.contact.address.country.value")) === -1
	) {
		payment4XForbiddenCause = <FormattedMessage id="error.payment.external.country.error" />;
	}

	const isPaiementPledg4xAvailable = checkIfPaymentPledg4xDisponible(state);

	return {
		booking: state.booking,
		selectedPaymentMode: state.booking.paymentMode,
		paymentTypes: getSupportedPaymentTypes(state),
		showAmountToPay: isOperatorMode(state),
		allowedPaymentTypes: getAllowedPaymentTypes(state),
		paymentModes: getPaymentModes(state),
		total: total,
		isPaiementPledg4xAvailable,
		mensualite2Fois: calculatePartialPaymentAmount(state),
		swissbilling: {
			forbiddenCause:
				total > state.payment.paymentSwissbilling.maxAmount ? (
					<FormattedMessage
						id="error.payment.swissbilling.max.error"
						values={{ maxAmount: state.payment.paymentSwissbilling.maxAmount }}
					/>
				) : (
					false
				),
			cgvURL: state.documents.payment.swissbillingCGV,
			maxAmount: state.payment.paymentSwissbilling.maxAmount,
		},
		casino: {
			forbiddenCause: !isPaiementPledg4xAvailable && payment4XForbiddenCause,
			mensualiteCasino: getEcheancierCasino(state),
			maxAmount: !isPaiementPledg4xAvailable && state.payment.payment4x.maxAmount,
		},
		isDepositEnabled: isDepositEnabled(state),
		isBookingEligibleForDeposit: isBookingEligibleForDeposit(state),
		shop: state.shop,
	};
};

const madDispatchToProps = dispatch => {
	return bindActionCreators(
		{
			updateBooking,
		},
		dispatch
	);
};

export const PaymentDataModeFirstContainer = connect(
	mapStateToProps,
	madDispatchToProps
)(PaymentDataModeFirst);
